import { render, staticRenderFns } from "./AnimateText.vue?vue&type=template&id=3d9714ae&"
import script from "./AnimateText.vue?vue&type=script&lang=ts&"
export * from "./AnimateText.vue?vue&type=script&lang=ts&"
import style0 from "./AnimateText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports